import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';
import { Heading } from '../Heading';

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            padding-bottom: ${theme.tggSpacing(rem(0.5), 1.25)};
        }
	`}
`;

export const StyledFiitSection = styled('section')`
    ${({ theme }: { theme: Theme }) => `
        margin-bottom: ${theme.tggSpacing(rem(4), 10)};

        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledFiitLogo = styled('img')`
    ${({ theme }: { theme: Theme }) => `
        width: ${theme.tggSpacing(rem(4.7), 19)};
        margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};

        ${theme.breakpoints.up('desktop')} {
            width: ${theme.tggSpacing(rem(6.5), 16.25)};
        }
	`}
`;
